export const ICON_SIZE = 24;
export const SLEEP_MINUTES = [5, 10, 15, 30, 60];
